import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { Box } from '@mui/material';

DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const MESSAGE_HTML_SX = {
  fontSize: '0.875rem',
  lineHeight: 1.6,
  wordBreak: 'break-word',
  '& p': { m: 0 },
  '& p + p': { mt: 1 },
  '& ul, & ol': { m: 0, mt: 0.5, pl: 2.5 },
  '& li': { mt: 0.5 },
  '& li p': { m: 0 },
  '& a': { color: 'inherit', textDecorationColor: 'currentColor' },
  '& strong, & b': { fontWeight: 600 },
  '& img': { maxWidth: '100%' },
};

export default function SanitizedHtml({ content, sx }) {
  const sanitized = useMemo(() => DOMPurify.sanitize(content ?? ''), [content]);

  return <Box sx={{ ...MESSAGE_HTML_SX, ...sx }} dangerouslySetInnerHTML={{ __html: sanitized }} />;
}
